import React, { ReactNode } from 'react';
import { classnames } from 'helpers/utils';
import { AlertTriangleIcon } from 'assets/icons';
import styles from './info-label.module.scss';

type InfoLabelProps = {
  content: React.ReactNode;
  icon?: ReactNode;
  finalIcon?: ReactNode;
  withIcon?: boolean;
  className?: string;
};

const InfoLabel: React.FC<InfoLabelProps> = ({
  content,
  icon,
  className = 'text__body__semi__bold__overline__gray700',
  withIcon = true,
  finalIcon,
}) => {
  const classes = [className, styles.statusLabel];
  return (
    <div className={classnames(...classes)}>
      {withIcon ? !icon && <AlertTriangleIcon className={styles.icon} /> : icon}
      {content}
      {!!finalIcon && finalIcon}
    </div>
  );
};

export { InfoLabel };
